import { Component, OnInit, Output, AfterViewInit, EventEmitter, Injector, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ComboboxItemDto, ListResultDtoOfComboboxItemDto } from '../../../../../../shared/service-proxies/service-proxies';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { startWith, map, finalize, debounceTime } from 'rxjs/operators';
import { WarehouseServiceProxy } from './../../../../../../shared/service-proxies/service-proxies';
import { AppComponentBase } from './../../../../../../shared/app-component-base';


@Component({
  selector: 'kt-autocomplete-combo',
  templateUrl: './autocomplete-combo.component.html',
  styleUrls: ['./autocomplete-combo.component.scss']
})
export class AutocompleteComboComponent extends AppComponentBase implements OnInit, AfterViewInit {

  @Input() placeHolder : string;
  @Input() defaultForm : boolean = false;


    @Input() dataSource : Observable<ListResultDtoOfComboboxItemDto> ;

  @Output() selectedOption :  ComboboxItemDto  = null ;
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();

  formControl : FormControl = new FormControl() ;
  items : ComboboxItemDto[] = [];
  filteredOptions: Observable<ComboboxItemDto[]>;
  



  
  constructor(
    injector : Injector
    
  ) { 
    super(injector);
    
    this.dataSource = new Observable<ListResultDtoOfComboboxItemDto>(null);
  }

  ngOnInit() {
   
  
  }

  ngAfterViewInit() {
    this.loadDataOnService();
  }
  loadDataOnService(): void{
   
   

    this.dataSource
      .subscribe(result => {
        this.items = result.items ;
        
        //Kullanicinin default olarak secilmis firmasi...
        var selectedItem = this.items.filter((val)=>{
          return val.isSelected == true ;
        });
        //  alert(JSON.stringify(selectedItem));
        //Combodan secili hale getirilir.
        if (selectedItem.length > 0){
          this.formControl.setValue(selectedItem[0].displayText);
          this.selectedOption = selectedItem[0] ;
        }
        
        
        this.filteredOptions = this.formControl.valueChanges
			.pipe(
			debounceTime(500),
            startWith(''),
            finalize(()=>{
              //this.viewLoading.next(false);
            }),
            map(value => {
             console.log('Girilen Deger', value);
             

              const filterValue = value.toLowerCase();

              const fl = this.items.filter(option => option.displayText.toLowerCase().includes(filterValue));
              
              return fl;
            })
          );

  });

  }

  clearCombo(): void{
    this.formControl.setValue('');
    //this.formControl.reset();
    this.selectedOption = null ;
    
    this.onEmit();
  }

  

  onSelect(e): void{
    var a = e.option;
    const selectedCustomerName = e.source.value;
    
    //Combodan secilen item.
    const selectedItem = this.items.filter(option => option.displayText.toLowerCase().includes(selectedCustomerName.toLowerCase()));

    this.selectedOption = selectedItem[0];
    

    //var selectedItemValue  = this.selectedOption.value;
    //console.log("Secilen Customer", selectedItemValue);
    this.onEmit();
  }

  onEmit(){
    if (this.onSelectedItem){
      this.onSelectedItem.emit();
    }
  }

}
